import { Navigate, Route, Routes } from 'react-router';
import App from './pages/app';
import Maintenance from './pages/Maintenance';
import PropertyDetail from './pages/propertyDetail';
import PropertySearch from './pages/propertySearch';

export const getRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<App />}>
        <Route
          index
          element={<Navigate to='/taxTransparency/propertySearch' replace />}
        />
        <Route
          path='taxTransparency/propertySearch'
          element={<PropertySearch />}
        />
        <Route
          path='taxTransparency/property/:propertyId'
          element={<PropertyDetail />}
        />
        <Route
          path='taxTransparency/property/:propertyId/:ownerId'
          element={<PropertyDetail />}
        />
        <Route path='maintenance' element={<Maintenance />} />
        <Route
          path='*'
          element={<Navigate to='/taxTransparency/propertySearch' replace />}
        />
      </Route>
    </Routes>
  );
};
